import { API_URL } from '../../../constants';

export default function uploadBlogImage(options = {}) {
  return function withContext(context) {
    const url = `${API_URL}blog/upload`;
    return fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${context._token}`
      },
      body: options.formData
    }).then(response => {
      if (!response.ok) {
        return response.json().then(json => Promise.reject({
          error: true,
          status: response.status,
          description: json.message || 'Upload failed'
        }));
      }
      return response.json();
    });
  };
}
